import { render, staticRenderFns } from "./audioPlayer.vue?vue&type=template&id=963044c4"
import script from "./audioPlayer.vue?vue&type=script&lang=js"
export * from "./audioPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('963044c4')) {
      api.createRecord('963044c4', component.options)
    } else {
      api.reload('963044c4', component.options)
    }
    module.hot.accept("./audioPlayer.vue?vue&type=template&id=963044c4", function () {
      api.rerender('963044c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/audioPlayer.vue"
export default component.exports